import logo from "../../../components/common/icons/fc_logo.svg";
import PhoneIcon from "../../../components/common/icons/phone-icon.png";
import help_logo from "../../../components/common/icons/Help_icon.png";
import ProfileModal from "../modals/profileModal";
import TabModal from "../modals/tabModal";
import { useState, useEffect } from "react";
import { HeaderUI } from "./styles";
import { NavLink, useLocation } from "react-router-dom";
import { HamburgerMenuIcon, UserCircleIcon } from "../../common/icons/InlineIcons";
import { getLocale, history, getFeatureToggle } from "../../common/helpers";
import { useSelector, useDispatch } from "react-redux";
import { assetsHomeServices } from "../../../components/assets/home/services";
import { getUserNotificationCount } from "../modals/service";
import { TIME_CONSTANT, userConstants } from "../../user/Constants";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [toggleProfileModal, setToggleProfileModal] = useState(false);
  const [toggleTabModal, setToggleTabModal] = useState(false);
  const { user, loggedIn } = useSelector((state) => state.login);
  const currentUser =
    (Array.isArray(user?.user) && user.user[0]) ||
    (user?.user && !Array.isArray(user.user) ? user.user : null) ||
    (Array.isArray(user) && user[0]) ||
    (user && user.userAccountId ? user : null) ||
    {};
  const firstName = currentUser?.firstName ?? "";
  const fullName = currentUser?.fullName ?? "";
  const organizationId = currentUser?.organizationId ?? null;
  const userAccountId = currentUser?.userAccountId ?? null;
  const [assetId, setAssetId] = useState(null);
  const [notificationCount, setNotificationCount] = useState(null);

  const language = getLocale(window.location.pathname, true);

  useEffect(() => {
    async function fetchAssetID() {
      if (!user || !loggedIn || !organizationId) {
        return;
      }
      const containerId = await assetsHomeServices
        .getOrgContainers(organizationId)
        .then((r) => r.containerlist[0].containerId)
        .catch(() => console.log("please try again"));
      setAssetId(containerId);
    }
    fetchAssetID();
  }, [user, loggedIn, organizationId]);

  useEffect(() => {
    let retryCount = 0;
    let timeoutId;

    async function pollNotificationCount() {
      timeoutId = setTimeout(cancelPolling, TIME_CONSTANT.ONE_SECOND);
      if (!user || !loggedIn) {
        return;
      }

      if (!userAccountId) {
        return;
      }

      const notification = await getUserNotificationCount(userAccountId)
        .then((r) => {
          if (r !== undefined) {
            clearTimeout(timeoutId);
            retryCount = 0;
            return r.count;
          } else {
            retryCount++;
            if (retryCount < 4) {
              pollNotificationCount();
            } else {
              cancelPolling();
            }
          }
        })

        .catch((error) => {
          retryCount++;
          if (retryCount < 4) {
            pollNotificationCount();
          } else {
            cancelPolling();
          }
        });
      setNotificationCount(notification);
    }

    function cancelPolling() {
      clearTimeout(timeoutId);
      retryCount = 0;
    }
    pollNotificationCount();
    const intervalId = setInterval(() => {
      pollNotificationCount();
    }, TIME_CONSTANT.ONE_MINUTE);

    return () => {
      cancelPolling();
      clearInterval(intervalId);
    };
  }, [user, loggedIn, userAccountId]);

  const dispatch = useDispatch();

  const showMyNotificationsPopUp = () => {
    dispatch({
      type: userConstants.SHOW_MY_NOTIFICATIONS_POPUP,
      showMyNotificationsPopUp: true,
    });
  };

  const [clickCount, setClickCount] = useState(0);
  const [sequence, setSequence] = useState([]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e && e.key) {
        const key = e.key.toLowerCase();

        if (sequence.length === 3 && sequence.join("") !== "ab enter") {
          return;
        }

        if (key === "a" || key === "b" || key === " " || key === "enter") {
          setSequence((prevSequence) => [...prevSequence, key]);
        } else {
          setSequence([]);
        }
        if (key !== "a" && key !== "b" && key !== " " && key !== "enter") {
          setClickCount(0);
        }
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [clickCount]);

  useEffect(() => {
    if (clickCount === 3 && sequence.join("") === "ab enter") {
      openToggleFeature();
      setClickCount(0);
      setSequence([]);
    }
    if (clickCount !== 3 && sequence.join("") === "ab enter") {
      setClickCount(0);
      setSequence([]);
    }
    if (sequence.length === 4 && sequence.join("") !== "ab enter") {
      setClickCount(0);
      setSequence([]);
    }
    if (clickCount > 3) {
      setClickCount(0);
      setSequence([]);
    }
  }, [clickCount, sequence]);

  const handleNavbarClick = () => {
    if (sequence.join("").length === 1 && sequence.join("") !== "a") {
      setClickCount(0);
      setSequence([]);
    }
    if (sequence.join("").length === 2 && sequence.join("") !== "ab") {
      setClickCount(0);
      setSequence([]);
    }
    if (sequence.join("").length === 3 && sequence.join("") !== "ab ") {
      setClickCount(0);
      setSequence([]);
    }
    if (sequence.join("").length === 4 && sequence.join("") !== "ab enter") {
      setClickCount(0);
      setSequence([]);
    }
    setClickCount((prevCount) => prevCount + 1);
  };

  const openToggleFeature = () => {
    dispatch({
      type: userConstants.SHOW_FEATURE_TOGGLE,
      showFeatureToggle: true,
    });
  };

  const [activeTab, setActiveTab] = useState("");
  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location]);

  const siteMinderToggle = getFeatureToggle("SiteMinder MVP")[0]?.isVisible;
  const sopAccess = useSelector((state) => state.login.sopAccessAuthorized ?? false);

  return (
    <HeaderUI>
      <nav onClick={handleNavbarClick} className="main-navbar">
        <div className="navbar-body">
          <div className="logo-wrapper">
            <a
              className="fluke-logo-link"
              href={
                user && loggedIn
                  ? language + "/measurements"
                  : "https://www.fluke.com/"
              }
            >
              <img
                src={logo}
                className="fluke-logo"
                alt="logo"
                width="150"
                height="55"
                fetchPriority="high"
              />
            </a>

            {user && loggedIn ? (
              <>
                <div className="header-tabs">
                  <NavLink
                    exact
                    className={
                      window.location.pathname === language + "/fc/dashboard"
                        ? "active"
                        : "non-active-class"
                    }
                    to={language + "/fc/dashboard"}
                    activeClassName="active"
                    onClick={() => {
                      history.push(language + "/fc/dashboard");
                    }}
                  >
                    {t("DASHBOARD")}
                  </NavLink>
                  <NavLink
                    exact
                    to={language + "/measurements"}
                    className={
                      window.location.pathname === language + "/measurements" ||
                      activeTab.includes("measurements") ||
                      activeTab.includes("/saved-session") ||
                      activeTab.includes("/remote-monitoring")
                        ? "active"
                        : "non-active-class"
                    }
                    activeClassName="active"
                    onClick={() => {
                      history.push(language + "/measurements");
                    }}
                  >
                    {t("Measurements")}
                  </NavLink>
                  <NavLink
                    exact
                    to={`${language}/asset-dashboard/${assetId}`}
                    className={
                      activeTab.includes("/asset-dashboard")
                        ? "active"
                        : "non-active-class"
                    }
                    onClick={() => {
                      history.push(`${language}/asset-dashboard/${assetId}`);
                    }}
                  >
                    {t("Assets")}
                  </NavLink>
                  <NavLink
                    exact
                    to={language + "/work-orders/list"}
                    className={
                      activeTab.includes("/work-orders")
                        ? "active"
                        : "non-active-class"
                    }
                    onClick={() => {
                      history.push(language + "/work-orders/list");
                    }}
                  >
                    {t("Work Orders")}
                  </NavLink>
                  <NavLink
                    exact
                    to={language + "/team"}
                    onClick={() => {
                      history.push(language + "/team");
                    }}
                  >
                    {t("team")}
                  </NavLink>
                  <NavLink
                    exact
                    to={language + "/exports/list"}
                    onClick={() => {
                      history.push(language + "/exports/list");
                    }}
                  >
                    {t("exports")}
                  </NavLink>
                  <NavLink
                    exact
                    to={language + "/reports/list"}
                    onClick={() => {
                      history.push(language + "/reports/list");
                    }}
                  >
                    {t("Reports")}
                  </NavLink>
                  {siteMinderToggle && sopAccess && (
                    <NavLink
                      exact
                      to={language + "/sop"}
                      className={
                        activeTab.includes("/sop")
                          ? "active"
                          : "non-active-class"
                      }
                      activeClassName="active"
                      onClick={() => {
                        history.push(language + "/sop");
                      }}
                    >
                      SOP<span style={{ textTransform: "lowercase" }}>s</span>
                    </NavLink>
                  )}
                </div>
                <div className="header-user-profile">
                  <a
                    href="https://www.accelix.com/resources/quickstart/fluke-connect-handheld-tools"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    <img title="Help" src={help_logo} alt="help-icon" width="64" height="64" />
                  </a>
                  <div
                    onClick={() => setToggleProfileModal((prev) => !prev)}
                    className="user-logo"
                  >
                    <UserCircleIcon />
                    <span onClick={showMyNotificationsPopUp} className="badge">
                      {notificationCount ? notificationCount : ""}
                    </span>
                    {toggleProfileModal && <ProfileModal />}
                  </div>
                  <div
                    onClick={() => setToggleProfileModal((prev) => !prev)}
                    className="user-name"
                  >
                    <div title={fullName}>{fullName}</div>
                    <div title={` ${firstName}  teams`}>{firstName} teams</div>
                  </div>
                  <div
                    onClick={() => setToggleTabModal((prev) => !prev)}
                    style={{ display: "none" }}
                    className="burger-icon"
                  >
                    <HamburgerMenuIcon />
                    {toggleTabModal && <TabModal />}
                  </div>
                </div>
              </>
            ) : (
              <div className="nav-profile-section">
                <span className="nav-profile-about">
                  <a href="https://www.fluke.com/">{t("About")}</a>
                </span>
                <a href="tel:8008735853" className="phone-logo">
                  <img src={PhoneIcon} alt="phone-logo" loading="lazy" width="23" height="23" />
                </a>

                <div className="profile-section">
                  <div className="profile-logo">
                    <a href={language + "/stores/login"} aria-label={t("Sign in")}>
                      <UserCircleIcon aria-hidden="true" />
                    </a>
                  </div>
                  <span className="user-login">
                    <a href={language + "/stores/login"}>{t("Sign in")}</a>
                  </span>
                  <div className="vertical-divider"></div>
                  <span className="user-login">
                    <a href={language + "/stores/registration"}>
                      {t("Sign up")}
                    </a>
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>
    </HeaderUI>
  );
};

export default Header;
